import ReactDOM from "react-dom";
import { PrimeReactProvider } from "primereact/api";
import { ConfirmDialog } from "primereact/confirmdialog";
import Tailwind from "primereact/passthrough/tailwind";
import App from "./layouts/App";
import { Provider } from "react-redux";
import store from "./store";

import "./App.css";
import { ToastProvider } from "./hooks/ToastContext";
import TagManager from "react-gtm-module";


const isGtmEnabled = process.env.MIX_REACT_APP_GTM_ENABLED === "true" || process.env.MIX_REACT_APP_GTM_ENABLED === true;

if(isGtmEnabled) {
    // GTM Configuration
    const tagManagerArgs = {
        gtmId: process.env.MIX_REACT_APP_GTM_ID ?? 'GTM-KMPGZ4GN'
    };

    // Initialize GTM when the application starts
    TagManager.initialize(tagManagerArgs);
}

const Index = () => {
    const value = {
        appendTo: "self",
        unstyled: false,
        pt: Tailwind,
    };

    return (
        /**later a loader will be added */

        <Provider store={store}>
            <PrimeReactProvider value={value}>
                <ConfirmDialog
                    pt={{
                        root: "max-w-[500px]",
                    }}
                />
                <ToastProvider>
                    <App />
                </ToastProvider>
            </PrimeReactProvider>
        </Provider>
    );
};

export default Index;

if (document.getElementById("root")) {
    ReactDOM.render(<Index />, document.getElementById("root"));
}
